import { render, staticRenderFns } from "./AttendanceChatExpired.vue?vue&type=template&id=3862a552&scoped=true"
import script from "./AttendanceChatExpired.vue?vue&type=script&lang=js"
export * from "./AttendanceChatExpired.vue?vue&type=script&lang=js"
import style0 from "./AttendanceChatExpired.vue?vue&type=style&index=0&id=3862a552&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3862a552",
  null
  
)

export default component.exports